import { Link } from 'react-router-dom';
import { IconHammer } from '@tabler/icons-react';
import AdminLayout from '../../components/layout/AdminLayout';

/**
 * Generic placeholder for admin sub-pages that haven't been built yet.
 * Each unbuilt section uses this so the sidebar nav routes resolve
 * cleanly instead of 404'ing. Replaced page-by-page in Phase 4.2–4.5.
 */
export default function AdminSubPlaceholder({
  title,
  shipsIn,
  description,
}: {
  title: string;
  shipsIn: string;
  description: string;
}) {
  return (
    <AdminLayout title={title}>
      <div className="rounded-xl bg-surface border-2 border-dashed border-border p-10 text-center max-w-2xl mx-auto">
        <div className="w-14 h-14 rounded-2xl bg-warning-soft text-warning inline-flex items-center justify-center mb-4 shadow-sm">
          <IconHammer size={26} stroke={2} />
        </div>
        <p className="text-12 font-bold uppercase tracking-widest text-warning mb-2">{shipsIn}</p>
        <h2 className="text-22 font-bold text-heading mb-3">{title}</h2>
        <p className="text-14 font-medium text-gray-700 leading-relaxed">{description}</p>
        <Link
          to="/admin"
          className="inline-flex items-center gap-2 mt-6 h-11 px-5 rounded-md bg-primary text-[#FFFFFF] text-14 font-bold hover:bg-primary-hover shadow-sm"
        >
          ← Back to dashboard
        </Link>
      </div>
    </AdminLayout>
  );
}
